import React, { useEffect, useState } from 'react'
import {
	Button,
	Card,
	Descriptions,
	Input,
	Modal,
	Popover,
	Select,
	Space,
	Switch,
	Tag,
	message,
} from 'antd'
import { Text, View } from 'styles/reactnative'
import { Meta, MetaTitle, MetaView } from './styles'
import { CButton } from 'app/components/Common'
import { COLORS } from 'app/constants'
import ClassificationSelect from './ClassificationSelect'
import { useAllMembers } from 'app/hooks/adminUsers/members'
import CountrySelect from '../CountrySelect'
import BigNumber from 'bignumber.js'
import { useToken, useWindowDimensions } from 'app/hooks'
import PhoneSelect from '../PhoneSelect'
import UserInfoTabs from './UserInfoTabs'
import API from 'utils/api'
import PasswordChange from './PasswordChange'
import { useProfile } from '../../hooks/user/profilestore'
import EntryTime from '../PositionColumns/EntryTime'
import UserTag from '../UserTag'
import { useUserGroup } from '../../hooks/user/usergroups'
import TextArea from 'antd/es/input/TextArea'
import { TagWrap } from './UserInfoTabs/styles'
import KrwPrice from '../PositionColumns/KrwPrice'
import MinimalUserInfo from './MinimalUserInfo'

const UserContent = ({ showOpen, selectedData, defaultfold = false }) => {
	const { width } = useWindowDimensions()
	const { editUser, mutate: mutateUser } = useAllMembers()
	const [showForm, setShowForm] = useState(false)
	const [data, setData] = useState<any>(selectedData)
	const [balance, setBalance] = useState(data?.balance)
	const [countryCode, setCountryCode] = useState(data?.country_code)
	const [phone, setPhone] = useState(data?.phone)
	const [phoneCode, setPhoneCode] = useState(data?.phone_code)
	const [nickname, setNickname] = useState(data?.nickname)
	const [fullname, setFullname] = useState(data?.fullname)
	const [email, setEmail] = useState(data?.email)
	const [loginid, setID] = useState(data?.loginid)
	const [selectLevel, setSelectLevel] = useState<any>(data?.level ? String(data.level) : '')
	const [group, setGroup] = useState(data?.group?.split('|')[0])
	const [referralCode, setReferralCode] = useState(data?.referral_code)
	const [referralCount, setReferralCount] = useState(data?.referral_count)
	const [memo, setMemo] = useState(data?.memo)

	const [bankName, setBankName] = useState(data?.bank_name)
	const [bankAccount, setBankAccount] = useState(data?.bank_account)
	const [bankOwner, setBankOwner] = useState(data?.bank_owner)

	const [v1, setV1] = useState(data?.vaccount?.split('/')?.[0])
	const [v2, setV2] = useState(data?.vaccount?.split('/')?.[1])
	const [v3, setV3] = useState(data?.vaccount?.split('/')?.[2])

	const [detail, setDetail] = useState(false)

	const [secver, setSecver] = useState(data?.secver)

	const { type1 } = useUserGroup()
	const [wts, setWts] = useState(data?.wts)
	const [mts, setMts] = useState(data?.mts)
	const [app, setApp] = useState(data?.app)
	const [ios, setIos] = useState(data?.ios)

	const [fold, setFold] = useState(defaultfold)

	const [referralSetting, setReferralSetting] = useState<any>(
		data?.referral?.setting
	)
	const { mutate } = useProfile(selectedData)
	const { data: token } = useToken()

	const [mobileBlock, setMobileBlock] = useState(data?.mobile_block || false)

	const getUser = () => {
		API.get(
			`/admin/user/${isNaN(selectedData) ? 1 : selectedData}${
				detail ? '?detail=true' : ''
			}`,
			token + '',
			{}
		).then((res: any) => {
			if (res?.result?.success) {
				mutate(selectedData, res?.result?.result)
				setData(res?.result?.result)
				setMemo(res?.result?.result?.memo)
				setBalance(res?.result?.result?.balance)
				setCountryCode(res?.result?.result?.country_code)
				setNickname(res?.result?.result?.nickname)
				setFullname(res?.result?.result?.fullname)
				setEmail(res?.result?.result?.email)
				setID(res?.result?.result?.loginid)
				setPhone(res?.result?.result?.phone)
				setPhoneCode(res?.result?.result?.phone_code)
				setSelectLevel(res?.result?.result?.level ? String(res?.result?.result?.level) : '')
				setGroup(res?.result?.result?.group?.split('|')[0])
				setReferralCode(res?.result?.result?.referral_code)
				setReferralCount(res?.result?.result?.referral_count)
				setWts(res?.result?.result?.wts)
				setMts(res?.result?.result?.mts)
				setApp(res?.result?.result?.app)
				setIos(res?.result?.result?.ios)
				setSecver(res?.result?.result?.secver)

				setBankName(res?.result?.result?.bank_name)
				setBankAccount(res?.result?.result?.bank_account)
				setBankOwner(res?.result?.result?.bank_owner)

				setV1(res?.result?.result?.vaccount?.split('/')?.[0])
				setV2(res?.result?.result?.vaccount?.split('/')?.[1])
				setV3(res?.result?.result?.vaccount?.split('/')?.[2])

				if (!mobileBlock && res?.result?.result?.mobile_block) {
					setMobileBlock(res?.result?.result?.mobile_block)
				}
			}
		})
	}

	useEffect(() => {
		if(!showOpen) {
			setDetail(false)
		}
	}, [showOpen])

	useEffect(() => {
		getUser()
	}, [token, selectedData, showOpen, detail])

	const editForm = async () => {
		await editUser({
			...data,
			nickname,
			fullname,
			memo,
			loginid: loginid,
			email: email,
			phone: phone,
			group: group,
			country_code: countryCode,
			level: typeof selectLevel === 'number' ? selectLevel : (selectLevel ? Number(selectLevel) : 0),
			balance: balance,
			referral_code: referralCode,
			wts: wts ? 1 : 0,
			mts: mts ? 1 : 0,
			app: app ? 1 : 0,
			ios: ios ? 1 : 0,
			bank_name: bankName,
			bank_account: bankAccount,
			bank_owner: bankOwner,
			phone_code: phoneCode,
			mobile_block: mobileBlock,
		})

		setTimeout(() => {
			mutateUser(1)
		}, 200)
	}

	const toggleMobileBlock = async (isBlock: boolean) => {
		try {
			const res = await API.post('/admin/user/mobile-block', token + '', {
				userid: data?.id,
				isblock: isBlock
			})
			
			if (res?.result?.success) {
				message.success(isBlock ? '모바일 접속이 차단되었습니다.' : '모바일 접속이 허용되었습니다.')
				setMobileBlock(isBlock)
				// Update the data in state
				setData({...data, mobile_block: isBlock})
			} else {
				message.error('모바일 접속 차단 설정에 실패했습니다.')
			}
		} catch (error) {
			message.error('모바일 접속 차단 설정 중 오류가 발생했습니다.')
		}
	}

	const [passwordModalVisible, setPasswordModalVisible] = useState(false)
	const [newPassword, setNewPassword] = useState('')

	const handlePasswordReset = () => {
		setPasswordModalVisible(true)
		setNewPassword('')
	}

	const confirmPasswordReset = async () => {
		if (!newPassword) {
			message.error('비밀번호를 입력해주세요.')
			return
		}
		
		try {
			const res = await API.post('/admin/user/password', token + '', {
				id: data?.id,
				password: newPassword
			})
			
			if (res?.result?.success) {
				message.success('비밀번호가 초기화되었습니다.')
				setPasswordModalVisible(false)
				setNewPassword('')
			} else {
				message.error('비밀번호 초기화에 실패했습니다.')
			}
		} catch (error) {
			message.error('비밀번호 초기화 중 오류가 발생했습니다.')
		}
	}

	return (
		<View
			style={{
				flexDirection: width < 600 ? 'column' : 'row',
				justifyContent: 'space-between',
				alignItems: 'flex-start',
				width: '100%',
				height: '100%',
			}}>
			{/* 새로운 미니멀 디자인 좌측 영역 */}
			<div style={{
				width: width < 600 ? '100%' : fold ? '114px' : '30%',
				height: '100%',
				borderRight: '1px solid rgba(0, 0, 0, 0.06)',
			}}>
				<MinimalUserInfo
					data={data}
					showForm={showForm}
					setShowForm={setShowForm}
					fold={fold}
					setFold={setFold}
					loginid={loginid}
					setID={setID}
					selectLevel={selectLevel}
					setSelectLevel={setSelectLevel}
					group={group}
					setGroup={setGroup}
					nickname={nickname}
					setNickname={setNickname}
					fullname={fullname}
					setFullname={setFullname}
					email={email}
					setEmail={setEmail}
					phone={phone}
					setPhone={setPhone}
					phoneCode={phoneCode}
					setPhoneCode={setPhoneCode}
					countryCode={countryCode}
					setCountryCode={setCountryCode}
					referralCode={referralCode}
					setReferralCode={setReferralCode}
					bankName={bankName}
					setBankName={setBankName}
					bankAccount={bankAccount}
					setBankAccount={setBankAccount}
					bankOwner={bankOwner}
					setBankOwner={setBankOwner}
					memo={memo}
					setMemo={setMemo}
					secver={secver}
					setSecver={setSecver}
					mobileBlock={mobileBlock}
					setMobileBlock={toggleMobileBlock}
					wts={wts}
					setWts={setWts}
					mts={mts}
					setMts={setMts}
					app={app}
					setApp={setApp}
					ios={ios}
					setIos={setIos}
					type1={type1}
					detail={detail}
					setDetail={setDetail}
					balance={balance}
					onSave={editForm}
					onPasswordReset={handlePasswordReset}
					mutate={getUser}
				/>
			</div>

			<UserInfoTabs data={data} fold={fold} />
			
			<Modal
				title="비밀번호 초기화"
				open={passwordModalVisible}
				onOk={confirmPasswordReset}
				onCancel={() => {
					setPasswordModalVisible(false)
					setNewPassword('')
				}}
				okText="초기화"
				cancelText="취소"
				okButtonProps={{ danger: true }}
			>
				<p>정말로 {data?.fullname || data?.nickname}님의 비밀번호를 초기화하시겠습니까?</p>
				<Input.Password 
					placeholder="새 비밀번호 입력"
					value={newPassword}
					onChange={(e) => setNewPassword(e.target.value)}
					style={{ marginTop: 12 }}
				/>
			</Modal>
		</View>
	)
}

export default UserContent